import React from "react";
import "../styles/About.css";
import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="about">
      <h1>{t('about.title')}</h1>

      <h2>{t('about.section1Title')}</h2>
      <p>{t('about.section1Text1')}</p>
      <p>{t('about.section1Text2')}</p>

      <h2>{t('about.section2Title')}</h2>
      <p>{t('about.section2Intro')}</p>
      <ul>
        <li><strong>{t('about.modeCharacter')}</strong> — {t('about.modeCharacterDesc')}</li>
        <li><strong>{t('about.modeItem')}</strong> — {t('about.modeItemDesc')}</li>
        <li><strong>{t('about.modeGame')}</strong> — {t('about.modeGameDesc')}</li>
        <li><strong>{t('about.modeSword')}</strong> — {t('about.modeSwordDesc')}</li>
      </ul>

      <h2>{t('about.section3Title')}</h2>
      <p>{t('about.section3Text1')}</p>
      <p>{t('about.section3Text2')}</p>

      <h2>{t('about.section4Title')}</h2>
      <p>{t('about.section4Text1')}</p>
      <p>{t('about.section4Text2')}</p>
      <p>
        {t('about.section4Text3')}
        <br />
        👉 <a href="https://lps-consulting.fr" target="_blank" rel="noopener noreferrer">
          lps-consulting.fr
        </a>
      </p>

      <p className="about-disclaimer">{t('about.disclaimer')}</p>
    </div>
  );
}